export function BatchDeleteLineupTemplates(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/lineups/templates/batch`;
}

export function ClearInviteCode(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/invite-code`;
}

export function ConnectWithFogis(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/fogis/connect`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/groups`;
}

export function Delete(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}`;
}

export function ExportTeamMembers(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users/export`;
}

export function GenerateInviteCode(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/invite-code`;
}

export function GetFogisTeamNameAndCompetitions(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/fogis/team-name-and-competitions`;
}

export function JoinFromInviteCode(): string {
	return `/v1/me/invite-code`;
}

export function LinkFogisAssociation(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/link`;
}

export function LinkFogisClubTeams(organizationID: number, groupID: number, associationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/club/teams/link`;
}

export function LinkIbisTeam(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/ibis/teams/link`;
}

export function LinkProfixioTeam(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/profixio/teams/link`;
}

export function LinkSweHockeyClub(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/swehockey/clubs/link`;
}

export function ListFogisAssociationClubs(organizationID: number, groupID: number, associationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/clubs`;
}

export function ListFogisClubTeams(organizationID: number, groupID: number, associationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/club/teams`;
}

export function ListFogisSeasons(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/seasons`;
}

export function ListGroupFederationLinks(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/links`;
}

export function ListIbisTeamLinks(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/ibis/links`;
}

export function ListIbisTeams(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/ibis/teams`;
}

export function ListLineupGames(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/lineups/games`;
}

export function ListLineupTemplates(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/lineups/templates`;
}

export function ListLineupTemplatesTable(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/lineups/templates/table`;
}

export function ListProfixioTeamLinks(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/profixio/links`;
}

export function ListProfixioTeams(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/profixio/teams`;
}

export function ListSweHockeyClubLinks(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/swehockey/links`;
}

export function ListSweHockeyClubs(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/swehockey/clubs`;
}

export function PaymentProviderSettings(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/payment-provider-settings`;
}

export function PlayerSignupOverview(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/player-signup-overview`;
}

export function PurgeFogisClubTeam(organizationID: number, groupID: number, associationID: number, teamID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/club/teams/${teamID}/all`;
}

export function PurgeIbisTeam(organizationID: number, groupID: number, teamID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/ibis/teams/${teamID}/all`;
}

export function PurgeProfixioTeam(organizationID: number, groupID: number, teamRegistrationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/profixio/teams/${teamRegistrationID}/all`;
}

export function PurgeSweHockeyClub(organizationID: number, groupID: number, clubID: number, statEntityID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/swehockey/clubs/${clubID}/series/${statEntityID}/all`;
}

export function SearchAll(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/search`;
}

export function SearchFogisAssociations(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations`;
}

export function SearchForUsers(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users/search`;
}

export function SearchViewable(organizationID: number): string {
	return `/v1/organizations/${organizationID}/groups/search`;
}

export function SetFogisAssociationClub(organizationID: number, groupID: number, associationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/club`;
}

export function SetPerformanceReviewTemplate(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/performance-review-template`;
}

export function Show(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}`;
}

export function ShowAllGroupLinks(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/all-links`;
}

export function ShowChildren(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/children`;
}

export function ShowChildrenSettings(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/settings/children`;
}

export function ShowFeed(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/feed`;
}

export function ShowGroupLinks(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/links`;
}

export function ShowParent(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/parent`;
}

export function ShowSettings(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/settings`;
}

export function ShowUsers(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users`;
}

export function ShowUsersWithLatestPerformanceReview(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users/performance-reviews`;
}

export function TrainingSessionSummary(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/training-session-summary`;
}

export function TrainingSessionSummaryExport(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/training-session-summary/export`;
}

export function UnlinkFogisAssociation(organizationID: number, groupID: number, associationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}`;
}

export function UnlinkFogisClub(organizationID: number, groupID: number, associationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/club`;
}

export function UnlinkFogisClubTeam(organizationID: number, groupID: number, associationID: number, teamID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/fogis/associations/${associationID}/club/teams/${teamID}`;
}

export function UnlinkIbisTeam(organizationID: number, groupID: number, teamID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/ibis/teams/${teamID}`;
}

export function UnlinkProfixioTeam(organizationID: number, groupID: number, teamRegistrationID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/profixio/teams/${teamRegistrationID}`;
}

export function UnlinkSweHockeyClub(organizationID: number, groupID: number, clubID: number, statEntityID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/federation/swehockey/clubs/${clubID}/series/${statEntityID}`;
}

export function Update(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}`;
}

export function UpdateGroupOrder(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/sort-order`;
}

export function UpdateSettings(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/settings`;
}

export function UpdateUser(organizationID: number, groupID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/users/${userID}`;
}

